module.exports = __webpack_public_path__ + "static/img/1635.44f78bc.png";